document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-scroll]').forEach((el) => el.addEventListener('click', (event) => {
    const id = el.getAttribute('href');
    if (id && id.startsWith('#')) {
      event.preventDefault();
      document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  }));

  const toggle = document.querySelector('.mobile-toggle');
  const links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', () => {
      const isOpen = links.style.display === 'flex';
      links.style.display = isOpen ? 'none' : 'flex';
      links.style.position = 'absolute';
      links.style.top = '76px';
      links.style.left = '16px';
      links.style.right = '16px';
      links.style.flexDirection = 'column';
      links.style.padding = '18px';
      links.style.background = '#0b1020';
      links.style.border = '1px solid rgba(255,255,255,.1)';
      links.style.borderRadius = '16px';
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  // Keep the sticky header Add to Cart button synced with the selected product variant.
  const productVariantSelect = document.querySelector('.product-info select[name="id"]');
  const headerVariantInput = document.querySelector('[data-header-variant-id]');
  if (productVariantSelect && headerVariantInput) {
    productVariantSelect.addEventListener('change', () => {
      headerVariantInput.value = productVariantSelect.value;
    });
  }

  // Cart quantity controls. Setting a quantity to zero removes the item after Update order is clicked.
  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('.quantity-input');
    const minus = control.querySelector('[data-quantity-minus]');
    const plus = control.querySelector('[data-quantity-plus]');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      input.value = Math.max(0, Number.parseInt(input.value || '0', 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', () => {
      input.value = Math.max(0, Number.parseInt(input.value || '0', 10) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
